import Menu from "./Menu";
import { NavLink } from "react-router-dom";

import image1 from "../img/utpl.png";

function Header() {
  return (
    <>
      <div className="bg-[#004270] py-4 fixed w-full z-50">
        <div className="max-w-6xl m-auto px-6 sm:px-0">
          <div className="flex  justify-between">
            <div className="w-[100px]">
              <NavLink to="/">
                <img src={image1} alt="utpl" className="logo"></img>
              </NavLink>
            </div>

            <div>
              <NavLink 
              className="text-white px-4"
              to="/">Inicio</NavLink>
              <NavLink
                className="text-white px-4"
              to="/agenda">Agenda</NavLink>
              <a
                className="text-[#004270] bg-[#febe10] px-4 py-2 font-bold rounded-2xl"
                href="#registro"
              >
                Regístrate ahora
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
